import React, { useState, useRef, useEffect } from 'react';
import { FaComments, FaTimes, FaPaperPlane, FaRobot } from 'react-icons/fa';
import './Chatbot.css';

const faqs = [
  { keywords: ['service', 'services', 'offer', 'provide', 'do you'],
    answer: 'We offer 3 main services:\n1. Building Demolition\n2. Earthwork (Excavation & Foundation)\n3. Building Materials Supply (M-Sand, Wire, Cut Bricks)' },
  { keywords: ['demolition', 'demolish', 'tear down', 'knock down'],
    answer: 'We provide safe and professional building demolition services for residential, commercial, and industrial structures in Coimbatore. Contact us for a free quote!' },
  { keywords: ['earthwork', 'excavation', 'foundation', 'digging', 'earth'],
    answer: 'Our earthwork services include excavation, site preparation, soil nailing, foundation work, and site leveling across Coimbatore.' },
  { keywords: ['material', 'sand', 'm-sand', 'brick', 'wire', 'supply'],
    answer: 'We supply premium building materials:\n• Hi-tech M-Sand\n• High-quality Construction Wire\n• Precision Cut Bricks\nAll delivered to your site in Coimbatore.' },
  { keywords: ['price', 'cost', 'rate', 'charge', 'quote', 'estimate'],
    answer: 'Pricing depends on project size and requirements. Contact us for a FREE quote!\n📞 9894065756\n📧 srikrishcivilsupplier@gmail.com' },
  { keywords: ['contact', 'phone', 'call', 'reach', 'number', 'email'],
    answer: 'You can reach us at:\n📞 Phone: 9894065756\n📧 Email: srikrishcivilsupplier@gmail.com\n📍 Location: Coimbatore, Tamil Nadu' },
  { keywords: ['location', 'address', 'where', 'coimbatore', 'area', 'serve'],
    answer: 'We are based in Coimbatore and serve all areas including RS Puram, Gandhipuram, Saravanampatti, Peelamedu, Singanallur, Vadavalli, and all surrounding regions.' },
  { keywords: ['experience', 'years', 'old', 'established', 'since'],
    answer: 'SRI KRISH CIVIL SUPPLIER has 15+ years of experience in civil construction, serving 500+ projects and 300+ happy clients across Coimbatore.' },
  { keywords: ['time', 'duration', 'long', 'complete', 'finish', 'deadline'],
    answer: 'Project timelines vary based on scope. We are committed to on-time delivery. Contact us with your project details for an accurate timeline.' },
  { keywords: ['safe', 'safety', 'insured', 'license', 'certified'],
    answer: 'Yes! We are fully licensed, insured, and safety-certified. All our operations follow strict safety protocols and environmental standards.' },
  { keywords: ['hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening', 'start'],
    answer: 'Hello! Welcome to SRI KRISH CIVIL SUPPLIER 👋\nHow can I help you today? You can ask about our services, pricing, location, or contact details.' },
  { keywords: ['thank', 'thanks', 'bye', 'goodbye'],
    answer: 'Thank you for contacting SRI KRISH CIVIL SUPPLIER! Feel free to reach us anytime at 9894065756. Have a great day! 😊' },
];

const suggestions = [
  'What services do you offer?',
  'How to contact you?',
  'Where are you located?',
  'Get a price quote',
  'Years of experience',
];

function getBotReply(input) {
  const lower = input.toLowerCase();
  for (const faq of faqs) {
    if (faq.keywords.some(k => lower.includes(k))) {
      return faq.answer;
    }
  }
  return "I'm not sure about that. Please contact us directly:\n📞 9894065756\n📧 srikrishcivilsupplier@gmail.com\nWe'll be happy to help!";
}

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: 'Hi! I\'m the SRI KRISH CIVIL SUPPLIER assistant 👋\nHow can I help you today?' }
  ]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, typing]);

  const sendMessage = (text) => {
    const msg = text || input.trim();
    if (!msg) return;
    setMessages(prev => [...prev, { from: 'user', text: msg }]);
    setInput('');
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMessages(prev => [...prev, { from: 'bot', text: getBotReply(msg) }]);
    }, 800);
  };

  return (
    <div className="chatbot-wrapper">
      {open && (
        <div className="chatbot-box">
          <div className="chatbot-header">
            <div className="chatbot-header-info">
              <FaRobot className="chatbot-avatar-icon" />
              <div>
                <span className="chatbot-name">SKCS Assistant</span>
                <span className="chatbot-status">Online</span>
              </div>
            </div>
            <button className="chatbot-close" onClick={() => setOpen(false)}><FaTimes /></button>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`chat-msg ${msg.from}`}>
                {msg.from === 'bot' && <FaRobot className="bot-icon" />}
                <div className="chat-bubble">{msg.text}</div>
              </div>
            ))}
            {typing && (
              <div className="chat-msg bot">
                <FaRobot className="bot-icon" />
                <div className="chat-bubble typing">
                  <span></span><span></span><span></span>
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          <div className="chatbot-suggestions">
            {suggestions.map((s, i) => (
              <button key={i} className="suggestion-btn" onClick={() => sendMessage(s)}>{s}</button>
            ))}
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sendMessage()}
            />
            <button onClick={() => sendMessage()}><FaPaperPlane /></button>
          </div>
        </div>
      )}

      <button className="chatbot-toggle" onClick={() => setOpen(o => !o)}>
        {open ? <FaTimes /> : <FaComments />}
        {!open && <span className="chatbot-badge">Chat</span>}
      </button>
    </div>
  );
};

export default Chatbot;
